function validForm (form, formFunction) {
  form.validate((valid) => {
    if (valid) {
      formFunction()
    } else {
      return false
    }
  })
}

function confirmMessageBox (vueEntity, title, operation) {
  vueEntity.$confirm(title, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    operation()
  }).catch(() => {})
}

function handlerRes (vueEntity, res, handlerFunction) {
  if (res.code === 0) {
    handlerFunction()
  } else {
    if (res.errors !== null && res.errors !== undefined && res.errors.length !== 0) {
      let errors = res.errors
      for (let key in errors[0]) {
        vueEntity.$message.error(errors[0][key])
        return
      }
    } else {
      vueEntity.$message.error(res.msg)
    }
  }
}

export default {
  validForm: validForm,
  confirmMessageBox: confirmMessageBox,
  handlerRes: handlerRes
}



// WEBPACK FOOTER //
// ./src/assets/js/viewFunction.js